import React, { Component } from "react";
import WriteMessage from "../WriteMessage/WriteMessage";
import withRouter from "../../../withRouter/withRouter";
import "./Ticket.css";

class Ticket extends Component {
    constructor(props) {
        super(props);

        this.send = this.send.bind(this);
    }
    state = {
        id: null,
        subject: null,
        messages: null,
        status: null,
        time: null,
        attachmentToShow: null,
    };

    componentDidMount() {
        this.componentDidUpdate();
    }

    componentDidUpdate(prevProps, prevState) {
        let { connection, router, toast } = this.props;
        let prevId = prevProps && prevProps.router.params.id;
        let newId = router.params.id;

        if (!this.state.id || prevId != newId) {
            this.setState({ id: newId });
            connection
                .get_ticket(newId)
                .then((res) => {
                    let { subject, messages, status, time } =
                        res.data.tickets[0] || {};
                    this.setState({ subject, messages, status, time });
                })
                .catch((err) => {
                    toast(
                        "دریافت درخواست پشتیبانی",
                        "خطا در دریافت اطلاعات درخواست پشتیبانی رخ داد : " +
                            err,
                        " danger"
                    );
                });
        }
    }

    send(message, attachments) {
        let { connection, toast, router } = this.props;

        connection
            .append_message_to_ticket(this.state.id, {
                poster: "costumer",
                message: message,
                attachments: attachments,
                time: Date.now(),
            })
            .then((res) => {
                toast("پیام جدید", " پیام شما با موفقیت ارسال شد.", " confirm");
                this.setState({ messages: res.data.messages });
            })
            .catch((err) => {
                toast("پیام جدید", " خطا در ارسال پیام جدید" + err, " danger");
            });
    }

    render() {
        let { connection, toast } = this.props;
        let { subject, messages, status, time, attachmentToShow } = this.state;
        return (
            <div className="TicketComponent">
                {attachmentToShow && (
                    <div
                        className="maximize"
                        onClick={(ev) =>
                            this.setState({ attachmentToShow: null })
                        }
                    >
                        {attachmentToShow.type === "image" ? (
                            <img src={attachmentToShow.url} />
                        ) : (
                            <video
                                src={attachmentToShow.url}
                                autoPlay={false}
                            ></video>
                        )}
                    </div>
                )}
                <div className="TicketContainer">
                    {subject ? (
                        <div className="header">
                            <div className="subject primary">
                                {subject === "other"
                                    ? "متفرقه"
                                    : "سفارش شماره : " + subject}
                            </div>
                            <div className="time text mate">
                                {new Date(time).toLocaleString("fa-IR")}
                            </div>
                            <div className="status">
                                {status === "pending" ? (
                                    <div className="text danger">
                                        در انتظار پاسخ
                                        <i className="fa-solid fa-spinner"></i>
                                    </div>
                                ) : (
                                    <div className="text primary">
                                        پاسخ داده شده
                                        <i className="fa-solid fa-envelope-circle-check"></i>
                                    </div>
                                )}
                            </div>
                        </div>
                    ) : (
                        <i className="fa-solid fa-spinner"></i>
                    )}

                    <div className="newMessage">
                        <WriteMessage
                            connection={connection}
                            toast={toast}
                            send={this.send}
                        />
                    </div>

                    {subject ? (
                        <div className="messages">
                            {messages.reverse().map((message, index) => {
                                return (
                                    <div className="message" key={index}>
                                        <div className="header">
                                            <div className="poster text secondary">
                                                {message.poster === "costumer"
                                                    ? "شما:"
                                                    : "ادمین:"}
                                            </div>
                                        </div>
                                        <div className="message">
                                            {message.message}
                                        </div>
                                        {message.attachments && (
                                            <div className="attachments ">
                                                {message.attachments.map(
                                                    (attachment, id) => {
                                                        return (
                                                            <div
                                                                className="attachment"
                                                                key={index}
                                                                onClick={(
                                                                    ev
                                                                ) => {
                                                                    this.setState(
                                                                        {
                                                                            attachmentToShow:
                                                                                attachment,
                                                                        }
                                                                    );
                                                                }}
                                                            >
                                                                {attachment.type ===
                                                                "image" ? (
                                                                    <img
                                                                        src={
                                                                            attachment.url
                                                                        }
                                                                    />
                                                                ) : (
                                                                    <video
                                                                        src={
                                                                            attachment.url
                                                                        }
                                                                        autoPlay={
                                                                            false
                                                                        }
                                                                    ></video>
                                                                )}
                                                            </div>
                                                        );
                                                    }
                                                )}
                                            </div>
                                        )}
                                        <div className="time text mate">
                                            (
                                            {new Date(
                                                message.time
                                            ).toLocaleString("fa-IR")}
                                            )
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    ) : (
                        <i className="fa-solid fa-spinner"></i>
                    )}
                </div>
            </div>
        );
    }
}

export default withRouter(Ticket);
